import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import IconSuccessSmall from '@hotjar/shared-assets/images/icons/icon-success-small.png';

export const Label = styled.label`
  cursor: pointer;
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-bottom: 0;

  *[disabled] + & {
    cursor: pointer !important;
  }

  ${({ disabled }) =>
    disabled &&
    `
            opacity: 0.4;
            cursor: not-allowed;
        `}

  ${({ labelPlacement }) => {
    switch (labelPlacement) {
      case 'right':
        return 'flex-direction: row;';
      case 'left':
        return 'flex-direction: row-reverse;';
      case 'top':
        return 'flex-direction: column-reverse;';
      case 'bottom':
        return 'flex-direction: column;';
      default:
        return undefined;
    }
  }}
`;

export const Input = styled.input`
  opacity: 0;
  margin: 0;
  position: absolute;
`;

export const Toggle = styled.span`
  display: inline-block;
  width: 50px;
  height: 32px;
  margin: 5px;
  border-radius: 100px;
  transition: 400ms all;
  background: ${tokens.color.neutral_300};
  position: relative;

  ${Input}:checked + & {
    background: ${tokens.color.ui_active};
    transition: 250ms all;
  }

  ${({ size }) =>
    size === 'm' &&
    `
            width: 44px;
            height: 27px;
        `}

  ${({ size }) =>
    size === 's' &&
    `
            width: 37px;
            height: 23px;
        `}

    ${({ size }) =>
    size === 'xs' &&
    `
            width: 29px;
            height: 19px;
        `}
`;

export const Handle = styled.span`
  transition: 300ms all;
  position: absolute;
  left: 2px;
  top: 2px;
  display: block;
  width: 28px;
  height: 28px;
  border-radius: 40px;
  background-color: ${tokens.color.ui_background};
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 5px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.24), 0px 1px 3px rgba(0, 0, 0, 0.12);

  ${Input}:checked + span > & {
    background-image: url(${IconSuccessSmall});
    background-size: 12px;
    left: 20px;
  }

  ${({ size }) =>
    size === 'm' &&
    `
            width: 23px;
            height: 23px;

            ${Input}:checked + span > & {
                left: 19px;
            }
        `}

  ${({ size }) =>
    size === 's' &&
    `
            top:1px;
            width: 21px;
            height: 21px;

            ${Input}:checked + span > & {
                left: 14px;
            }
        `}

    ${({ size }) =>
    size === 'xs' &&
    `
            width: 15px;
            height: 15px;
            background-size: 10px !important;

            ${Input}:checked + span > & {
                left: 12px;
            }
        `}
`;

export const LabelText = styled.span`
  color: ${tokens.color.text_default};
  font-size: 11px;
  font-weight: 600;
  text-transform: none;
  text-align: center;
  transition: 400ms all;
  user-select: none;
  padding: 0 5px;

  ${({ size }) =>
    size === 'xs' &&
    `
            font-size: 10px;
        `}
`;
